import { useCollectionDataOnce } from 'react-firebase-hooks/firestore'
import { Form, Select } from 'semantic-ui-react'

import useFirebase from 'lib/hooks/useFirebase'
import { SyntheticEvent } from 'react'

const ModelPicker = ({
  make,
  model,
  onChange,
}: {
  make: string
  model: string
  onChange: (
    event: SyntheticEvent<HTMLElement, Event>,
    data: { value: string },
  ) => void
}) => {
  const firebase = useFirebase()
  const [docs, loading, error] = useCollectionDataOnce<{ models: string[] }>(
    make
      ? firebase
          .firestore()
          .doc('site/stats')
          .collection(`models`)
          .where('make', '==', make)
      : null,
  )

  return (
    <Form.Field>
      <label>Model</label>
      <Select
        fluid
        search
        options={
          loading || !make || !docs
            ? []
            : docs[0].models
                .sort((a, b) => a.localeCompare(b))
                .map(model => ({
                  key: model,
                  text: model,
                  value: model,
                }))
        }
        value={model}
        placeholder={
          !make || loading || error
            ? 'Pick a Make first'
            : 'Start typing to filter by vehicle model'
        }
        onChange={onChange}
        disabled={loading || !!error || !make}
        loading={loading}
      />
    </Form.Field>
  )
}

export default ModelPicker
